import { render, staticRenderFns } from "./mdy-pwd.vue?vue&type=template&id=625ad3c8&scoped=true&"
import script from "./mdy-pwd.vue?vue&type=script&lang=js&"
export * from "./mdy-pwd.vue?vue&type=script&lang=js&"
import style0 from "./mdy-pwd.vue?vue&type=style&index=0&id=625ad3c8&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "625ad3c8",
  null
  
)

export default component.exports